<ion-header translucent>
  <ion-toolbar>
    <ion-title>Trocar beneficiário</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">Fechar</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

  @if ((signedInPayee$ | async); as payee) {
    <ion-grid>
      @for (linkedPayee of (linkedPayees$ | async); track linkedPayee.id) {
        <ion-row>
          <ion-col>
            <app-artist-card 
              [payee]="linkedPayee"
              [self]="linkedPayee.id === (signedInPayee$ | async)?.id"
              [selected]="linkedPayee.id === (signedInPayee$ | async)?.id"
              version="simple"
              (click)="dismiss(linkedPayee)"
             />
          </ion-col>
        </ion-row>
      }
    </ion-grid>
  }
</ion-content>

